import { detailsBigCss, detailsSmallCss } from "@/styles/typography";
import styled from "styled-components";

export const StyledDefaultButton = styled.a`
  ${detailsBigCss}
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: fit-content;
  padding: 20px 48px 16px 48px;
  color: ${({ theme }) => theme.textColors.secondary};
  border: 2px solid ${({ theme }) => theme.textColors.secondary};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  white-space: nowrap;
  text-align: center;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
      border: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    ${detailsSmallCss}
    height: 46px;
    max-width: 100%;
    width: 100%;
  }
`;
